<template>
    <v-container class="fill-height">
        <v-card  elevation=0 >
        

            <v-card-text>
                <v-row>
                    <v-col cols="12" md="12" sm="12" class="text-center">
                        <div class="headline">Thank You For Your Feedback</div>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" md="12" sm="12" class="text-center">
                        <v-btn @click="home" color="primary">Back to Business Overview</v-btn>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" md="12" sm="12" class="text-center">
                        <v-card class="card-back">
                            <v-row>
                                    <v-col cols="12" md="12" sm="12" class="text-center " >
                                        <div>Latest Update</div>
                                    </v-col>
                                    <v-col cols="12" md="12" sm="12" class="text-center ">
                                    <v-btn href="https://www.who.int/emergencies/diseases/novel-coronavirus-2019" target="_blank" color="primary">Read</v-btn>
                                    </v-col>
                            </v-row>
                        </v-card>

                        <v-card class="mt-3 card-back">
                            <v-row>
                                <v-col cols="12" md="12" sm="12" class="text-center " >
                                    <div>LEARN MORE ABOUT COVID-19</div>
                                </v-col>
                                <v-col cols="12" md="12" sm="12" class="text-center ">
                                    <v-btn href="https://www.who.int/emergencies/diseases/novel-coronavirus-2019" target="_blank" color="primary">Read</v-btn>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import Vue from 'vue'
export default {
    data: () => 
        ({
            bannerImg:require('@/assets/overview-banner.jpg'),
        }),
    methods:{
        home()
        {
       
            this.$router.push({name:'bDetails'});
            //this.$router.push({name:'coronasurvey'});
            this.activeBtn=0;
            //this.currentSection='overview';
        },
    }
}
</script>
<style>
.pb-80
{
    padding-bottom: 80px;
}
.card-back{
    background: #f7f7f7 !important;
}
</style>